import { InjectionToken } from '@angular/core';
import { LogEvent } from '../utils/log-event.model';
import { LogTypes } from '../utils/log-types.model';

/**
 * Logger Injection token
 */
export const CbreLoggerToken = new InjectionToken<CbreLogger>('CbreLogger');

/**
 * Logger Interface. Implementations should implement and expose the following methods:
 * ```
 * info(message: string | T): void;
 * debug(message: string | T): void;
 * warn(message: string | T): void;
 * error(error: string | Error | HttpErrorResponse | T): void;
 * ```
 */
export interface CbreLogger {
  info(message: string | LogEvent): void;
  debug(message: string | LogEvent): void;
  warn(message: string | LogEvent): void;
  error(error: LogTypes): void;
}
